import { useTranslation } from 'react-i18next'
import { useUpdateStatus } from '../../../hooks/useUpdateStatus'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogFooter,
  DialogTitle,
  DialogDescription,
} from '../../ui/dialog'
import './UpdateDialog.scss'

export function UpdateDialog() {
  const { t } = useTranslation()
  const { state, download, dismiss } = useUpdateStatus()

  if (state.status !== 'error') return null

  return (
    <Dialog open onOpenChange={(open) => { if (!open) dismiss() }}>
      <DialogContent hideCloseButton onPointerDownOutside={e => e.preventDefault()}>
        <DialogHeader>
          <DialogTitle>{t('updater.errorTitle')}</DialogTitle>
          <DialogDescription>
            {t('updater.errorDetail', {
              message: state.errorMessage ?? t('updater.errorUnknown'),
            })}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <button
            className="update-dialog__button update-dialog__button--secondary"
            onClick={dismiss}
          >
            {t('updater.close')}
          </button>
          <button
            className="update-dialog__button update-dialog__button--primary"
            onClick={download}
          >
            {t('updater.retry')}
          </button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
